var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    {
      staticClass: "p-3 h-100 rounded-0",
      class: _vm.businessCardStyle,
      attrs: { "no-body": "" }
    },
    [
      _c("div", { staticClass: "d-flex flex-row" }, [
        _c(
          "div",
          { staticClass: "mr-3 h-100 mb-3" },
          [
            _vm._t("bcImage", [
              _c("div", { staticClass: "circle rounded-circle" }, [
                _c("img", {
                  class: {
                    "rounded-circle": _vm.imageSrc,
                    "default-avatar": !_vm.imageSrc
                  },
                  attrs: {
                    height: _vm.businessCardImageHeight,
                    width: _vm.businessCardImageWidth,
                    alt: _vm.$t("message.avatar.default"),
                    src: _vm.source
                  }
                })
              ])
            ])
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column pt-1 mt-2 w-100" }, [
          _c("h5", { staticClass: "text-left mb-3" }, [
            _vm._v("\n        " + _vm._s(_vm.name)),
            _c("br"),
            _vm._v(" "),
            _vm.relation
              ? _c("small", { staticClass: "text-muted font-italic" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.businessCard.relation")) +
                      " " +
                      _vm._s(_vm.relation) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.userTitle
            ? _c("div", { staticClass: "text-left" }, [
                _vm._v("\n        " + _vm._s(_vm.userTitle) + "\n      ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.contractNumber
            ? _c("div", { staticClass: "text-left" }, [
                _vm._v("\n        " + _vm._s(_vm.contractNumber) + "\n      ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.createdAtFormatted
            ? _c("div", { staticClass: "text-left" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.createdAtFormatted) + "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.roles
            ? _c("div", { staticClass: "text-left" }, [
                _vm._v("\n        " + _vm._s(_vm.roles) + "\n      ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.dateOfBirthFormatted
            ? _c("div", { staticClass: "text-left" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.dateOfBirthFormatted) + "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.email
            ? _c("div", { staticClass: "text-left" }, [
                _vm._v("\n        " + _vm._s(_vm.email) + "\n      ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.phone
            ? _c("div", { staticClass: "text-left" }, [
                _vm._v("\n        " + _vm._s(_vm.phone) + "\n      ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.status
            ? _c("div", { staticClass: "text-left" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.businessCard.status")) +
                    " " +
                    _vm._s(_vm.status) +
                    "\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.dateOfDeathFormatted
            ? _c("div", { staticClass: "text-left" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.businessCard.deceased")) +
                    " " +
                    _vm._s(_vm.dateOfDeathFormatted) +
                    "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.showIcon
          ? _c("div", [_c("span", { staticClass: "cross" }, [_vm._v("†")])])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-left" }, [_vm._t("bcFooter")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a73e3658", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a73e3658","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BusinessCard.vue
// module id = wjQg
// module chunks = 1